import React from "react";
import freespiritsCover from "../../../albums/freespirits_cover.jpg";
import freespirits_song1 from "../../../music/freespirits-song1.mp3";
import freespirits_song2 from "../../../music/freespirits-song2.mp3";
import freespirits_song3 from "../../../music/freespirits-song3.mp3";
import PlayerCard from "../PlayerCard";

const Freespirits = {
  cover: freespiritsCover,
  songs: [
    {
      name: "Taffanel: Andante Pastoral Et Scherzettino: I. Andante Pastoral",
      subtitle: "Monika Ruth Vida & Noémi Győri",
      mp3: freespirits_song1,
    },
    {
      name: "Fauré: Fantaisie, Op. 79: II. Allegro",
      subtitle: "Monika Ruth Vida & Noémi Győri",
      mp3: freespirits_song2,
    },
    {
      name: "Mel Bonis: Flute Sonata in C-Sharp Minor, Op. 64: IV. Finale. Moderato - Grazioso",
      subtitle: "Monika Ruth Vida & Noémi Győri",
      mp3: freespirits_song3,
    },
  ],
};

export const FreespiritsAlbum = () => {
  const language = { eng: "true" };

  return (
    <PlayerCard
      cover={Freespirits.cover}
      songs={Freespirits.songs}
      buyLink={"https://music.apple.com/gb/album/free-spirits/6810582232"}
      bookletLink={"https://www.noemigyori.com/freespirits-booklet"}
      language={language}
      listen={true}
    />
  );
};
